import { defineMessages } from "@/i18n";
import en from "./en";

export const canvasMessages = defineMessages("canvas", en);
